'use client';

import Image from '@/components/Image';
import { useJump } from '@/components/MagicJump';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { env } from '@/utils/env';
import { useTranslations } from '@/i18n/use-translations';
const SubscribeCoupon = ({ bottomSubscribeBoxTxt = '' }: { bottomSubscribeBoxTxt?: string }) => {
  const token = useStore((state) => state.token);
  const userInfo = useStore((state) => state.userInfo);
  const setLoginRegisterShow = useStore((state) => state.setShowLoginRegisterDialog);
  const t = useTranslations('layout.footer');
  const toJumpTarget = useJump();

  const handleOnTabSubscribe = () => {
    if (token) {
      toJumpTarget({
        Jump_target: `/account/my-account?email=${userInfo?.email}`,
        jump_type: 4,
      });
    } else {
      setLoginRegisterShow({
        show: true,
        eventType: 'bottom_register',
        situation: '底部导航领券',
      });
    }
  };
  return (
    <>
      <WapOnly>
        <div className="flex flex-col items-center pt-[30px] pr-10 pb-0 pl-10">
          <b
            className="inline-block w-[286px] text-center leading-[24px] text-[16px] font-br font-normal text-primary-white"
            dangerouslySetInnerHTML={{ __html: bottomSubscribeBoxTxt }}
          />
          <div className="mt-16 flex items-center" onClick={handleOnTabSubscribe}>
            <div className="w-[222px] h-[40px] leading-[40px] bg-primary-white rounded-[4px_0_0_4px] box-border pl-10 text-12 text-secondary-text">
              {t('subscribe.emailPlaceholder')}
            </div>
            <div className="h-[40px] leading-[40px] w-[94px] rounded-[0_4px_4px_0] text-center bg-primary-purple text-primary-white font-bb text-14">
              {t('subscribe.subscribeButton')}
            </div>
          </div>
        </div>
      </WapOnly>
      <WebOnly>
        <div
          className={`flex items-center bg-primary-black text-primary-white p-[73px_48px] ${env.NEXT_PUBLIC_HAS_APP === 'true' ? 'justify-between' : 'justify-center'}`}
        >
          {env.NEXT_PUBLIC_HAS_APP === 'true' ? (
            <div>
              <p className="text-[28px] leading-[34px] font-bb">
                {t('downloadApp.title')}
                <br />
                {t('downloadApp.saveMore')}
              </p>
              <div className="flex">
                <div className="group relative block pt-24 w-[210px] mr-18 cursor-pointer">
                  <Image
                    src="/home-page/ios-app.png"
                    alt={t('downloadApp.appStore')}
                    className="w-[210px]"
                    width={210}
                    height={54}
                  />
                  <Image
                    src="/home-page/app-download-qrcode.png"
                    alt={t('downloadApp.appStore')}
                    className="absolute top-[-270%] left-0 w-full h-auto hidden group-hover:block"
                    width={210}
                    height={210}
                  />
                </div>
                <div className="group relative block pt-24 w-[210px] cursor-pointer">
                  <Image
                    src="/home-page/ios-google.png"
                    alt={t('downloadApp.googlePlay')}
                    className="w-[210px]"
                    width={210}
                    height={54}
                  />
                  <Image
                    className="absolute top-[-270%] left-0 w-full h-auto hidden group-hover:block"
                    src="/home-page/app-download-qrcode.png"
                    alt={t('downloadApp.appStore')}
                    width={210}
                    height={210}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          <div className="flex flex-col justify-start">
            <div
              className="text-ellipsis line-clamp-2 break-words whitespace-pre-line w-full font-bb text-28 leading-[34px] mb-18"
              dangerouslySetInnerHTML={{ __html: bottomSubscribeBoxTxt }}
            />
            <div
              className="flex justify-center w-[54.8vw] h-[62px] cursor-pointer"
              onClick={handleOnTabSubscribe}
            >
              <div className="flex-1 pl-10 leading-[62px] text-secondary-text rounded-[4px_0_0_4px] box-border h-full border-1 border-r-0 border-auxiliary-dark-gray">
                {t('subscribe.emailPlaceholder')}
              </div>
              <div className="w-[180px] bg-primary-purple text-center leading-[62px] text-primary-white font-bb rounded-[0_4px_4px_0]">
                {t('subscribe.subscribeButton')}
              </div>
            </div>
          </div>
        </div>
      </WebOnly>
    </>
  );
};

export default SubscribeCoupon;
